
import React, { Fragment } from 'react';
import { Typography, TableCell, TableRow } from '@mui/material';
import PrimaryTable from "../../../../../Shared/components/PrimaryTable";
import { NavLink } from "react-router-dom"
import PrintIcon from "../../../../../../assets/images/icon_actions/Print.svg";
import { Image } from "antd";
import { DeliveryAccordionComponent } from "../../../../../Shared/components/AccordionComponent";


export const ProductDetails = (props) => {
    const { classes, details, clsx, loadMore, handlePrint } = props;
    const heads = [
        { 'key': 'product', 'name': 'Product' },
        { 'key': 'productId', 'name': 'Product ID' },
        { 'key': 'quantity', 'name': 'Quantity' },
        { 'key': 'role', 'name': 'Unit' },
        { 'key': 'actions', 'name': 'Actions' },
    ];
    return (
        <div className={classes.productDetails}>
            {
                loadMore ? (<div className={classes.loadMoreCircle}></div>) : (
                    <Fragment>
                        {
                            details && Object.keys(details).length > 0 ? Object?.entries(details)?.map(([key, value]) => (
                                <DeliveryAccordionComponent
                                    key={key}
                                    expand={true}
                                    detailClasses={classes.accordionInvoiceDetails}
                                    title={<Typography className={clsx(classes.typographyHeader, classes.bold, classes.fonSize15)}>{value?.invoices[0]?.customerName}</Typography>}
                                    component={
                                        <>
                                            {
                                                value.invoices && value.invoices?.length > 0 ? value.invoices?.map((data, i) => (
                                                    <DeliveryAccordionComponent
                                                        key={`invoices_${i}`}
                                                        detailClasses={classes.accordionInvoiceDetails}
                                                        title={<Typography
                                                            className={clsx(classes.typographyHeader, classes.bold, classes.fonSize13)}><span>{data?.serialNo} </span>
                                                            <span className={classes.totalQuantity}>
                                                                <span> Total Quantity </span><span>
                                                                    {
                                                                        data?.salesInvoiceItems ? data?.salesInvoiceItems.reduce((a, v) => a = a + v.quantity, 0) : 0
                                                                    }
                                                                </span>
                                                            </span></Typography>}
                                                        component={<PrimaryTable
                                                            heads={heads}
                                                            component={
                                                                <>
                                                                    {
                                                                        data?.salesInvoiceItems?.length > 0 ? data?.salesInvoiceItems?.map((d, i) => (
                                                                            <TableRow key={`product_${i}`} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                                                <TableCell style={{ width: "50%" }}><span style={{ width: "50%" }}>{d?.product?.name || d?.description || '---'}</span></TableCell>
                                                                                <TableCell><span>{d?.product?.productId || '---'}</span></TableCell>
                                                                                <TableCell><span>{d?.quantity || '---'}</span></TableCell>
                                                                                <TableCell><span>{d?.unit?.name || '---'}</span></TableCell>
                                                                                <TableCell>
                                                                                    <NavLink to={`#`} onClick={() => handlePrint('productSingle', data.id, d.id)}>
                                                                                        <Image
                                                                                            src={PrintIcon}
                                                                                            preview={false}
                                                                                        />
                                                                                    </NavLink>
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        )) :
                                                                            (
                                                                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                                                    <TableCell className={classes.textAlignCenter} colSpan={5}>
                                                                                        {
                                                                                            <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>
                                                                                                This space will display all query once you start creating it
                                                                                            </p>
                                                                                        }
                                                                                    </TableCell>
                                                                                </TableRow>
                                                                            )
                                                                    }
                                                                </>
                                                            }
                                                        />}
                                                    />
                                                )) : <></>
                                            }
                                        </>
                                    }
                                />
                            )) : <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>
                                This space will display all query once you start creating it
                            </p>
                        }
                    </Fragment>
                )
            }
        </div>
    )
}

